import React, {Component} from 'react'
import NRTVerticalStack from "../../_common/_containers/VerticalStack"
import NRTHorizontalStack from "../../_common/_containers/HorizontalStack"
import NRTFormInput from "../../_common/_form/FormInput"
import {Validators} from "../../_common/_form/Validators"

class MCSaleFormBuyer extends Component {


    updatePayerInfo(personDTO) {

        if (personDTO) {
            Object.keys(personDTO)
                .forEach(k => {
                    const input = this.refs[k + 'Input']
                    const value = personDTO[k]

                    if (input)
                        this.refs[k + 'Input'].setValue(value)

                })

            if (personDTO.addressDTO) {
                Object.keys(personDTO.addressDTO)
                    .forEach(k => {

                        const input = this.refs[k + 'AddressInput']
                        const value = personDTO.addressDTO[k]


                        if (input && !!value)
                            this.refs[k + 'AddressInput'].setValue(value)
                    })
            }


        }
    }


    updateAddress(address) {

        const {
            bairro,
            localidade,
            logradouro,
            uf
        } = address

        this.refs.neighborhoodAddressInput.setValue(bairro)
        this.refs.cityAddressInput.setValue(localidade)
        this.refs.streetAddressInput.setValue(logradouro)
        this.refs.stateAddressInput.setValue(uf)
    }


    render() {

        return (

            <NRTVerticalStack>


                <NRTFormInput
                    ref={'loginInput'}
                    name={'buyer.login'}
                    label={'login*'}
                    type={'hidden'}


                />

                <NRTFormInput
                    ref={'codeInput'}
                    name={'buyer.code'}
                    label={'code'}
                    type={'hidden'}


                />

                <NRTFormInput
                    ref={'cpfCnpjInput'}
                    name={'buyer.cpfCnpj'}
                    label={'CNPJ*'}
                    type={'cpf'}
                    validators={[Validators.cnpj()]}
                    customProps={{cpf: false}}
                />

                <NRTHorizontalStack smFractions={[]}>
                    <NRTFormInput
                        ref={'companyInput'}
                        name={'buyer.company'}
                        label={'Razão Social*'}
                        validators={[Validators.required()]}
                    />

                    <NRTFormInput
                        ref={'fantasyNameInput'}
                        name={'buyer.fantasyName'}
                        label={'Fantasia*'}
                        validators={[Validators.required()]}
                    />

                </NRTHorizontalStack>

                <NRTFormInput
                    ref={'stateRegistrationInput'}
                    name={'buyer.stateRegistration'}
                    label={'Inscrição Estadual'}
                />

                <NRTFormInput
                    ref={'emailInput'}
                    name={'buyer.email'}
                    label={'E-mail para envio de NFe*'}
                    validators={[
                        Validators.required(),
                        Validators.email()
                    ]}
                />


                <NRTFormInput
                    ref={'cepAddressInput'}
                    name={'buyer.addressDTO.cep'}
                    type={'cep'}
                    label={'CEP*'}
                    validators={[Validators.cep()]}
                />


                <NRTHorizontalStack fractions={[2, 1, 1]}>
                    <NRTFormInput
                        ref={'streetAddressInput'}
                        name={'buyer.addressDTO.street'}
                        label={'Rua*'}
                        validators={[Validators.required()]}
                    />

                    <NRTFormInput
                        ref={'numberAddressInput'}
                        name={'buyer.addressDTO.number'}
                        label={'Número'}
                    />

                    <NRTFormInput
                        ref={'complementAddressInput'}
                        name={'buyer.addressDTO.complement'}
                        label={'Complemento'}
                    />
                </NRTHorizontalStack>


                <NRTFormInput
                    ref={'neighborhoodAddressInput'}
                    name={'buyer.addressDTO.neighborhood'}
                    label={'Bairro*'}
                    validators={[Validators.required()]}
                />

                <NRTHorizontalStack fractions={[2, 1]}>

                    <NRTFormInput
                        ref={'cityAddressInput'}
                        name={'buyer.addressDTO.city'}
                        label={'Cidade*'}
                        validators={[Validators.required()]}
                    />

                    <NRTFormInput
                        ref={'stateAddressInput'}
                        name={'buyer.addressDTO.state'}
                        label={'Estado*'}
                        validators={[Validators.required()]}
                    />

                </NRTHorizontalStack>
            </NRTVerticalStack>
        )
    }
}


MCSaleFormBuyer
    .propTypes = {}
MCSaleFormBuyer
    .defaultProps = {}


export default MCSaleFormBuyer



// WEBPACK FOOTER //
// ./src/components/_sale/FormBuyer/index.js